import {
  FETCH_FLASHCARD,
  FETCH_ALL_FLASHCARDS,
  CREATE_FLASHCARDS,
  DELETE_FLASHCARDS,
  UPDATE_FLASHCARDS,
} from '../constants/actionTypes';

const flashcards = (flashcards = [], action) => {
  switch (action.type) {
    case CREATE_FLASHCARDS:
      return [...flashcards, action.payload];
    case UPDATE_FLASHCARDS:
      return flashcards.map((flashcard) =>
        flashcard._id === action.payload._id ? action.payload : flashcard,
      );
    case FETCH_FLASHCARD:
      return action.payload;
    case FETCH_ALL_FLASHCARDS:
      return action.payload;
    case DELETE_FLASHCARDS:
      return flashcards.filter((flashcard) => flashcard._id !== action.payload);
    default:
      return flashcards;
  }
};

export default flashcards;
